import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Context } from '@grandvisionhq/carts-v2';
import { Loader, Modal } from '@grandvisionhq/common';
import { Alert } from '@grandvisionhq/iris-ui';
import { useIntl, useFeatureToggles } from '@grandvisionhq/state';
import { useDynamicModule } from '@grandvisionhq/utils';
import { pushLoginExpressEditUserDetailsClickEventToDataLayer } from '../../../../../data-layer.js';
import '../../../../../StepShipping/selectors.js';
import 'lodash/isEmpty';
import '../../../../../mappers/errors-mapping.js';
import '../../../../../utils/get-customer-details-payload.js';
import '../../../../../models/cart/cart-state.js';
import '../../../../../models/checkout/checkout-step-error-type.js';
import '../../../../../models/checkout-settings.js';
import '../../../../../models/step-shipping/shipping-methods.js';
import '../../../../../models/shared.js';
import 'history';
import '../../../../../utils/has-cart-errors.js';
import '@grandvisionhq/payments';
import '@grandvisionhq/auth';
import '../../../../../context/CheckoutSettings/context.js';
import '../../../../../selectors.js';
import '@grandvisionhq/graphql';
import '@grandvisionhq/lib-utils-cart';
import '@grandvisionhq/svc-tealium/events';
import '../../../../../operations/mutations/set-customer-details.js';
import '../../../../../operations/mutations/set-service-store.js';
import '../../../../../operations/mutations/set-shipping-method.js';
import '../../../../../operations/mutations/set-shipping-state.js';
import '../../../../../operations/mutations/create-apple-pay-session.js';
import '../../../../../operations/mutations/recreate-ordered-checkout.js';
import { useSetServiceStore } from '../../../../../hooks/operations/use-set-service-store.js';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/fun-orders';
import '@grandvisionhq/analytics';
import '../../../../../operations/fragments/checkout-mutation-result.js';
import '../../../../../operations/fragments/cart-mutation-failures.js';
import '../../../../../operations/fragments/recreate-ordered-checkout-failure.js';
import '../../../../../operations/fragments/recreate-ordered-checkout-result.js';
import '../../../../../operations/fragments/paypal-payment.js';
import '../../../../../operations/fragments/saved-user-details.js';
import '../../../../../operations/queries/get-checkout-state.js';
import '../../../../../operations/queries/get-user-details.js';
import { StoreFinderItemContainer } from '../../../../../modules/ServiceStore/containers/StoreFinderItemContainer.js';
import { useLoggedInCheckout } from '../../../../context/context.js';
import '@grandvisionhq/lib-utils-w3c';
import { ServiceStoreSummaryContainer } from './ServiceStoreSummaryContainer.js';

const loadModule = function() {
    var _ref = swcHelpers.asyncToGenerator(function*() {
        const storesModule = yield import('@grandvisionhq/stores-v2');
        return storesModule;
    });
    return function loadModule() {
        return _ref.apply(this, arguments);
    };
}();
const usePickupStoresModule = ()=>useDynamicModule(loadModule, '@grandvisionhq/stores-v2', [])
;
const ServiceStore = ({ globalStoreId: globalStoreId1 , title , isServiceStoreValid , isOrderDetailsValid  })=>{
    const { cart  } = Context.useCart();
    const [pickupStoresModule, isLoadingPickupStores, pickUpStoreModuleError] = usePickupStoresModule();
    const { getLabel  } = useIntl();
    const featuresToggles = useFeatureToggles();
    const { isUserLoggedIn  } = useLoggedInCheckout();
    const [showModal, setShowModal] = React.useState(false);
    const { setServiceStore  } = useSetServiceStore();
    const labels = React.useMemo(()=>({
            title: getLabel('checkout.serviceStore.title'),
            subtitle: getLabel('checkout.serviceStore.subtitle'),
            errorMessage: getLabel('checkout.serviceStore.error')
        })
    , [
        getLabel
    ]);
    const handleStoreFinder = React.useCallback(function() {
        var _ref = swcHelpers.asyncToGenerator(function*(globalStoreId) {
            if (!globalStoreId) return;
            const shouldFetchStore = cart && !(cart === null || cart === void 0 ? void 0 : cart.serviceStore);
            if (shouldFetchStore) {
                yield setServiceStore(globalStoreId);
            }
        });
        return function(globalStoreId) {
            return _ref.apply(this, arguments);
        };
    }(), [
        cart,
        setServiceStore
    ]);
    React.useEffect(()=>{
        handleStoreFinder(globalStoreId1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        globalStoreId1
    ]);
    const onStoreSelect = React.useCallback(function() {
        var _ref = swcHelpers.asyncToGenerator(function*(store) {
            if (store === null || store === void 0 ? void 0 : store.globalStoreId) {
                yield setServiceStore(store === null || store === void 0 ? void 0 : store.globalStoreId);
            }
            setShowModal(false);
        });
        return function(store) {
            return _ref.apply(this, arguments);
        };
    }(), [
        setServiceStore
    ]);
    const onEditHandler = React.useCallback(()=>{
        pushLoginExpressEditUserDetailsClickEventToDataLayer({
            editType: isServiceStoreValid ? 'edit_service_store' : 'add_service_store_alert',
            isLoggedIn: isUserLoggedIn
        });
        setShowModal(true);
    }, [
        isServiceStoreValid,
        isUserLoggedIn
    ]);
    if (pickUpStoreModuleError || !pickupStoresModule) {
        return /*#__PURE__*/ React.createElement(Alert, {
            variant: "error",
            notifyScreenReader: false,
            className: "alert-m-default"
        }, labels.errorMessage);
    }
    const { Components , Containers , StoreFinderProvider  } = pickupStoresModule;
    const { StoreFinder , PickUpButtons , withPickUpButtonsConfig  } = Containers;
    const { StoreListTopContent  } = Components;
    if (isLoadingPickupStores) {
        return /*#__PURE__*/ React.createElement(Loader, null);
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Modal, {
        className: "service-store__modal",
        showIcon: true,
        iconClassName: "service-store__modal__close",
        isOpen: showModal,
        onModalClose: ()=>setShowModal(false)
    }, /*#__PURE__*/ React.createElement(StoreFinderProvider, {
        googleMapsId: "google-maps-service-store",
        hidePhone: !featuresToggles.isStorePickupPhoneEnabled,
        hideEmail: !featuresToggles.isStorePickupEmailEnabled
    }, /*#__PURE__*/ React.createElement(StoreFinder, {
        isInsideModal: true,
        listTopContent: /*#__PURE__*/ React.createElement(StoreListTopContent, {
            title: labels.title,
            description: labels.subtitle
        }),
        listItemComponent: (props)=>/*#__PURE__*/ React.createElement(StoreFinderItemContainer, swcHelpers.extends({}, props, {
                variant: 'list-item',
                onClick: onStoreSelect
            }))
        ,
        infoWindowContentComponent: (props)=>/*#__PURE__*/ React.createElement(StoreFinderItemContainer, swcHelpers.extends({}, props, {
                variant: 'map-item',
                onClick: onStoreSelect
            }))
        ,
        buttonsComponent: withPickUpButtonsConfig(PickUpButtons, {
            onStoreSelect
        })
    }))), /*#__PURE__*/ React.createElement(ServiceStoreSummaryContainer, {
        isOrderDetailsValid: Boolean(isOrderDetailsValid),
        isServiceStoreValid: Boolean(isServiceStoreValid),
        title: title,
        onEditHandler: onEditHandler
    }));
};

export { ServiceStore };
//# sourceMappingURL=ServiceStore.js.map
